import { render, staticRenderFns } from "./EmojiImageUpload.vue?vue&type=template&id=22590121&scoped=true"
import script from "./EmojiImageUpload.vue?vue&type=script&lang=js"
export * from "./EmojiImageUpload.vue?vue&type=script&lang=js"
import style0 from "./EmojiImageUpload.vue?vue&type=style&index=0&id=22590121&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22590121",
  null
  
)

export default component.exports